
import GasStation from "../../../assets/outline/GasStation.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GasStationIcon({ className, dataTestid = "GasStationIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GasStation data-testid={dataTestid} className={classes} {...rest} />
  );
}
